import levenshteinDistance from '../utils/levenshteinDistance';


export const questionOptionsForSelectMultipleThatMatchSpokenAnswer = (
    questionAnswerValue: any,
    spokenAnswer: String,
    questionOptions: Array<string>
) => {

    // keep any existing options
    const matchingOptions: string[] = questionAnswerValue && questionAnswerValue instanceof Array ? [...questionAnswerValue] : []

    // split spoken answer into an array of individual words
    // const spokenWords = spokenAnswer.toLowerCase().split(' ')

    // // check if any of the spoken words match the question options
    // questionOptions.forEach((option: string) => {
    //     if (spokenWords.includes(option.toLowerCase())) {
    //         matchingOptions.push(option)
    //     } else {
    //         // if not an exact match, check if any of the spoken words are close matches to the option (levenshtein distance of 1 or less)
    //         for (const word of spokenWords) {
    //             const distance = levenshteinDistance(option.toLowerCase(), word);
    //             const threshold = option.length <= 2 ? 0 : 1; // Allow a distance of 0 for short options, 1 for longer options
    //             if (distance <= threshold) {
    //                 matchingOptions.push(option)
    //                 break;
    //             }
    //         }
    //     }
    // })

    let matchedOption: string | null = null
    const normalizedAnswer = spokenAnswer.trim().toLowerCase();

    // 1. Check for exact match (case-insensitive)
    for (const option of questionOptions) {
        const distance = levenshteinDistance(option.toLowerCase(), normalizedAnswer);
        const threshold = option.length <= 3 ? 0 : 1; // Allow a distance of 1 for short options, 2 for longer options
        if (distance <= threshold) {
            matchingOptions.push(option)
            const uniqueOptions = Array.from(new Set(matchingOptions))
            return uniqueOptions
        }
    }

    // 2. Check if any single word uniquely identifies one option
    const answerWords = normalizedAnswer.split(/\s+/)

    for (const word of answerWords) {
        const matches = questionOptions.filter(option => {
            // loop through options and check if any of the words in the spoken answer are close matches to the option (levenshtein distance of 1 or less) or if the option includes the word
            for (const optionWord of option.toLowerCase().split(" ")) {
                const distance = levenshteinDistance(optionWord, word);
                const threshold = optionWord.length <= 3 ? 0 : 1;
                if (distance <= threshold) {
                    console.log(`match found: "${optionWord}" for spoken word "${word}" with distance ${distance}`);
                    return option;
                } else {
                    console.log(`no match: "${optionWord}" for spoken word "${word}" with distance ${distance} - threshold ${threshold}`);
                }
            }
            return false;
        }
        )

        // If exactly one option matches this word, return it -
        // this is because we might have 'big flood, small flood' 'major alert, minor alert' 'not radioactive' 'very radioactive' etc
        if (matches.length === 1) {
            matchedOption = matches[0]
            matchingOptions.push(matchedOption)
            break
        }
    }

    // remove any duplicates
    const uniqueOptions = Array.from(new Set(matchingOptions))

    return uniqueOptions
}

